import apiService from '@/services/apiService';

const actions = {
  getMainHeader({ commit }, payload) {
    apiService.get(`paxelmarket/config/main-header`)
      .then((response) => {
        commit('getMainHeader', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postMainHeader({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put('paxelmarket/config/main-header', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
